export default {
  PAGE: 1,
  LIMIT: 20
}
